import type { EngagementDot as Value } from '../api/types';

const TITLES: Record<Value, string> = {
  active: 'Active in the last 48h',
  idle: 'Idle (no activity 2-6 days)',
  silent: 'Silent (no activity 7+ days)',
};
const CLASSES: Record<Value, string> = {
  active: 'bg-success',
  idle: 'bg-idle',
  silent: 'bg-danger',
};

export default function EngagementDot({ value }: { value: Value }) {
  return (
    <span title={TITLES[value]}
          className={`inline-block h-2 w-2 flex-none rounded-full ${CLASSES[value]}`} />
  );
}
